import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap: LocalizedString = {
	[Locale.cs]: "/o-nas",
	[Locale.en]: "/about-us",
	[Locale.sk]: "/o-nas",
};

export function getAboutPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
